import { GASharedEventCategory as c } from "../../constants/googleAnalytics.js";
import * as m from "ramda";
import { useCallback as t } from "react";
const w = () => {
  const a = t(() => m.isNil(window.dataLayer) ? (console.warn("cannot find window.dataLayer(), skip GTM emit"), !1) : !0, []), n = t(
    (e) => {
      a() && window.dataLayer.push({
        event: c.ConsentUpdate,
        ad_personalization: e,
        ad_storage: e,
        ad_user_data: e,
        analytics_storage: e
      });
    },
    [a]
  ), o = t(
    (e, s) => {
      a() && (window.dataLayer.push({ parameter: null }), window.dataLayer.push({
        event: e,
        parameter: s
      }));
    },
    [a]
  ), r = t(
    (e) => {
      a() && window.dataLayer.push({
        user_id: e
      });
    },
    [a]
  ), d = t(() => {
    n("granted");
  }, [n]), i = t(() => {
    n("denied");
  }, [n]);
  return {
    gtmEmitEvent: o,
    gtmConfigUserId: r,
    gtmAcceptConsent: d,
    gtmDeclineConsent: i
  };
};
export {
  w as default
};
//# sourceMappingURL=useGoogleTagManager.js.map
